/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { alpha } from '@mui/material';

interface Item {
  color?: string;
  isHover: boolean;
  isSelected: boolean;
}

export const root: SxStyle = {};

export const container: SxStyleFunc<string | undefined> = (color) => ({
  width: (p) => p.spacing(36.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color ? color : (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(1),
  mx: 'auto',
  mt: (p) => p.spacing(3),
  mb: (p) => p.spacing(1),
});

export const header: SxStyle = {
  backgroundColor: (p) => p.palette.grey[200],
  m: (p) => p.spacing(1.75),
  mt: (p) => p.spacing(2.5),
  px: (p) => p.spacing(2.5),
  py: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
};

export const headerTitle: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const headerDes: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  color: (p) => p.palette.grey[700],
};

export const progressWrapper: SxStyle = {
  width: '100%',
  height: '6px',
  borderRadius: '6px',
  background: (p) => p.palette.grey[400],
};

export const credit: SxStyle = {
  p: (p) => p.spacing(1, 1.5),
  mx: (p) => p.spacing(1.75),
  borderRadius: (p) => p.spacing(0.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[50],
};

export const creditCount: SxStyle = {
  mb: (p) => p.spacing(0.5),
  mr: (p) => p.spacing(2.5),
};

export const creditTitle: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
};

export const creditTotal: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const creditUsage: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  color: (p) => p.palette.grey[500],
};

export const progress: SxStyleFunc<string | undefined> = (color) => ({
  height: '100%',
  width: '15%',
  borderRadius: '6px',
  background: color ? color : (p) => p.palette.primary[500],
});

export const creditTime: SxStyle = {
  mt: (p) => p.spacing(2),
};

export const creditTimeIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};

export const creditTimeTitle: SxStyleFunc<string | undefined> = (color) => ({
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: color ? color : (p) => p.palette.primary[500],
});

export const creditTimeDes: SxStyleFunc<string | undefined> = (color) => ({
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  color: color ? color : (p) => p.palette.primary[500],
});

export const item: SxStyleFunc<Item> = ({ color, isHover, isSelected }) => ({
  pl: (p) => p.spacing(2.5),
  py: (p) => p.spacing(0.75),
  fontSize: (p) => p.typography.caption.fontSize,
  backgroundColor:
    isSelected && color
      ? color
      : isSelected
      ? (p) => p.palette.primary[500]
      : isHover
      ? alpha(color || '#1851EF', 0.09)
      : 'transparent',

  color: isSelected
    ? (p) => p.palette.common.white
    : (p) => p.palette.common.black,
});

export const itemTitle: SxStyle = {
  pl: (p) => p.spacing(2.5),
  mt: (p) => p.spacing(2),
  mb: (p) => p.spacing(1.25),
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const itemIcon: SxStyleFunc<Item> = ({ color, isSelected }) => ({
  color: isSelected
    ? (p) => p.palette.common.white
    : color
    ? color
    : (p) => p.palette.primary[500],
});
